<template>
    <div v-if="related.length" class="w-full mt-4 mb-3 print:hidden">
        <div class="border-t-2 border-blue-600">
            <div class="tan-control-box pb-1">
                <div>
                    <div class="select-title pt-1 pb-1 print:hidden">Related {{ label }}s:</div>
                    <!-- <p class="select-title-chart w-full sm:w-auto align-top sm:mt-1 mb-1">Related {{ label }}s:</p> -->
                    <div class="inline-block mb-1">
                        <div class="relative inline-block">
                            <select v-model="modelSelected" class="form-control form-control-sm form-control-fixed bg-white mb-1" aria-label="Related">
                                <option :value="null">Select...</option>
                                <option :value="instrument.symbol" v-for="instrument in related">{{ instrument.symbolName }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="ml-1 mb-1 text-center flex md:inline-flex md:justify-start justify-center items-center print:hidden">
                        <div class="btn btn-yellow btn-sm" @click="navigate">Go to {{ label }} Chart</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    related: {
        type: Array,
        required: true
    },
    label: {
        type: String,
        required: true
    }
});

const modelSelected = ref(null);
function navigate() {
    if (!modelSelected.value) return;
    const route = window.route('interactive-charts.home', { symbol: modelSelected.value });
    window.location = route;
}
</script>
